/* eslint import/prefer-default-export: "off" */
export const autocomplete_session_id = 'autocomplete_session_id'
export const storagePrefix = `SailPoint.Cloud.Access.Management`

declare global {
  interface Window {
    __PROTOCOL__: string
    __OAUTH_CLIENT_ID__: string
    __ENABLE_SSO__: boolean
    __OAUTH_PROVIDER__: string
    __OAUTH_PROVIDER_CODE__: string
    __HOST__: string
    __WEB_PORT__: string
    ABORT_CONTROLLER: AbortController
  }
}
